import { render, staticRenderFns } from "./TableSettings.vue?vue&type=template&id=82bb20da&scoped=true&"
import script from "./TableSettings.vue?vue&type=script&lang=ts&"
export * from "./TableSettings.vue?vue&type=script&lang=ts&"
import style0 from "./TableSettings.vue?vue&type=style&index=0&id=82bb20da&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82bb20da",
  null
  
)

export default component.exports